export default "__VITE_ASSET__Dp08Nw_f__"